import React from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Toaster } from '../ui/sonner';
import Header from './Header';
import HeroSection from './HeroSection';
import ProblemSection from './ProblemSection';
import FeaturesSection from './FeaturesSection';
import ProcessSection from './ProcessSection';
import AuditFormSection from './AuditFormSection';
import BookingSection from './BookingSection';
import TestimonialsSection from './TestimonialsSection';
import FAQSection from './FAQSection';
import Footer from './Footer';
import Chatbot from './Chatbot';
import FloatingBookButton from './FloatingBookButton';
import FloatingWhatsAppButton from './FloatingWhatsAppButton';

const LandingPage = () => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleBookCall = () => {
    scrollToSection('booking');
  };

  const handleGetAudit = () => {
    scrollToSection('audit');
  };

  const handleAdminLogin = (credentials) => {
    // Store credentials and navigate to admin
    localStorage.setItem('pixzent_admin_auth', JSON.stringify(credentials));
    navigate('/admin');
  };

  return (
    <div className="min-h-screen bg-white">
      <Toaster position="top-right" richColors />
      
      <Header
        onBookCall={handleBookCall}
        onGetAudit={handleGetAudit}
      />
      
      <main>
        <HeroSection
          onBookCall={handleBookCall}
          onGetAudit={handleGetAudit}
        />
        <ProblemSection onGetAudit={handleGetAudit} />
        <FeaturesSection />
        <ProcessSection />
        <AuditFormSection />
        <BookingSection />
        <TestimonialsSection />
        <FAQSection />
      </main>
      
      <Footer
        onBookCall={handleBookCall}
        onGetAudit={handleGetAudit}
        onAdminLogin={handleAdminLogin}
      />
      
      <Chatbot />
      <FloatingWhatsAppButton />
      <FloatingBookButton />
    </div>
  );
};

export default LandingPage;
